// extracted by css-extract-rspack-plugin
export default {"wrapper":"n2eBH7A___wrapper","container":"Yg0YYvU___container","title":"du2zjV2___title"};